import Diamond1 from '../Diamond/Diamond (1).webp'
import Diamond2 from '../Diamond/Diamond (2).webp'
import Diamond3 from '../Diamond/Diamond (3).webp'
import Diamond4 from '../Diamond/Diamond (4).webp'


const Diamondimages =[
Diamond1,Diamond2,Diamond3,Diamond4
]

export default Diamondimages;